import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { cartTotalStyles } from "@dana/Overrides/Widgets/Cart/CartTotal";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

cartTotalStyles.saveOrderButton = mergeToNew(cartTotalStyles.saveOrderButton, {
    css: css`
        margin-top: 10px;
    `,
});

cartTotalStyles.cartTotal = mergeToNew(cartTotalStyles.cartTotal, {
    container: {
        css: css`
            padding: 16px;
        `,
    },
    subtotalLabel: {
        weight: fontWeights.regular,
    },
    promotionLabel: {
        weight: fontWeights.regular,
    },
    discountsLabel: {
        weight: fontWeights.regular,
    },
    shippingAndHandlingLabel: {
        weight: fontWeights.regular,
    },
    otherChargesLabel: {
        weight: fontWeights.regular,
    },
    totalLabel: {
        weight: fontWeights.regular,
    },
    subtotalValue: {
        weight: fontWeights.semiBold,
        css: css`
            text-align: right;
        `
    },
    promotionValue: {
        weight: fontWeights.semiBold,
        css: css`
            text-align: right;
        `
    },
    discountsValue: {
        weight: fontWeights.semiBold,
        css: css`
            text-align: right;
        `
    },
    shippingAndHandlingValue: {
        weight: fontWeights.semiBold,
        css: css`
            text-align: right;
        `
    },
    otherChargesValue: {
        weight: fontWeights.semiBold,
        css: css`
            text-align: right;
        `
    },
    taxValue: {
        weight: fontWeights.semiBold,
        css: css`
            text-align: right;
        `
    },
    totalValue: {
        weight: fontWeights.semiBold,
        css: css`
            text-align: right;
        `
    },
});